import * as React from "react";

import { User, UserJSON } from "../models/users";
import { GoldCoin } from "../Toolbar/GoldCoin";
import { SilverCoin } from "../Toolbar/SilverCoin";
import { AvatarList } from "../DesignSystem/AvatarList";
import { RLink } from "../DesignSystem/RLink";

export const UserCard = (props: {
  user: UserJSON;
  showProfile: boolean;
  simple?: boolean;

  main_entries?: number;
  side_entries?: number;

  onClick?: () => void;
}) => {
  const { user, showProfile, main_entries, side_entries, onClick } = props;
  const userModel = new User(user);

  if (user.banned) {
    return <div></div>;
  }

  const hasProfile = userModel.profile && userModel.profile.trim().length > 0;

  return (
    <div className="rounded-lg px-3 py-3 transition-colors hover:bg-slate-100 dark:hover:bg-slate-700/50">
      <div className="flex items-center gap-3">
        <AvatarList users={[userModel]} />

        <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
          <RLink
            onClick={(e) => {
              if (onClick) {
                e.preventDefault();
                onClick();
              }
            }}
            to={`/user/${userModel.username}`}
            className="text-lg font-medium text-slate-800 hover:text-violet-600 dark:text-white dark:hover:text-violet-400"
          >
            {user.username}
          </RLink>

          {!props.simple && (
            <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-slate-500 dark:text-slate-400">
              <span>LV {userModel.level}</span>
              <span>XP {userModel.experience}</span>
              {main_entries !== undefined && <span>{main_entries} main</span>}
              {side_entries !== undefined && <span>{side_entries} side</span>}
              <span className="flex items-center gap-1">
                {userModel.gold} <GoldCoin />
              </span>
              <span className="flex items-center gap-1">
                {userModel.silver} <SilverCoin />
              </span>
            </div>
          )}
        </div>
      </div>

      {showProfile && hasProfile && (
        <div
          className="prose ml-14 mt-2 border-l-2 border-slate-300 pl-3 text-sm italic text-slate-600 dark:border-slate-600 dark:text-slate-400"
          dangerouslySetInnerHTML={{ __html: userModel.profile_escaped }}
        />
      )}
    </div>
  );
};
